var portfolioPositionsTopFlop = {
	caption: {
		top: "Risultati posizioni top di portafoglio",
		flop: "Risultati posizioni flop di portafoglio",
		gainers: "Portfolio positions gainers",
		losers: "Portfolio positions losers"
	},
	name: "Nome",
	isin: "ISIN",
	lastPrice: "Ultimo",
	lastPriceDateTime: "Ultimo appuntamento",
	unrealizedPerformance: "Unrealized perf. in {currency}",
	unrealizedPerformanceRelative: "Utile/Perdita %",
	unrealizedPerformanceBar: "Utile/Perdita % di max",
	weight: "Ponderazione %",
	marketValue: "Market value in {currency}",
	actions: "Azioni",
	noPositions: "Nessun risultato trovato."
};
var it = {
	portfolioPositionsTopFlop: portfolioPositionsTopFlop
};

export { it as default, portfolioPositionsTopFlop };
